<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
    <div class="iq-card-body ">
      <b-form @submit.prevent="handleSubmit(submit)" ref="OrdersForm">
        <div class="iq-card-header ">
          <div class="iq-header-title">
            <h4 class="card-title">
              {{ pageTitle }}
            </h4>
          </div>
        </div>

        <FormGenerator
          :Fields="fields"
          :model="formData"
          :options="options"
          globalClass="w-100"
        />
        <div>
          <b-spinner
            v-if="loading"
            variant="primary"
            label="Spinning"
          ></b-spinner>
          <button v-else type="submit" class="btn btn-primary">
            {{ buttonName }}
          </button>
        </div>
      </b-form>
    </div>
  </ValidationObserver>
</template>
<script>
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { Fields, options, models } from "./form_fields";
import { getOrderData, getStatusOptions } from "@/API/OrdersAPIs";
export default {
  name: "Form",
  components: {
    FormGenerator
  },
  props: [
    "id",
    "pageTitle",
    "buttonName",
    "isInList",
    "model",
    "businessId",
    "branchId",
    "isCreateMode",
    "loading"
  ],
  data() {
    return {
      formData: JSON.parse(JSON.stringify(models)),
      options,
      fields: Fields,
      emptyModel: null
    };
  },
  async created() {
    await this.loadData();
  },
  async mounted() {
    this.emptyModel = models;

    this.formData.branchId = this.branchId;
    this.formData.businessId = this.businessId;
    this.options.statusOptions = await getStatusOptions();
    if (this.options.statusOptions.length > 1) {
      this.formData.type = this.options.statusOptions[1].value;
    }
    const typeField = this.fields.find(field => field.name === "status");
    if (typeField) {
      typeField.options = this.options.statusOptions;
    }
  },
  watch: {
    async id(val) {
      if (this.id)
        var props = {
          branchId: this.branchId,
          businessId: this.businessId,
          id: val
        };
      this.formData = await getOrderData(props);
    },
    model: {
      deep: true,
      handler(value) {
        this.formData = { ...this.formData, ...value };
        console.log(value);
      }
    }
  },
  methods: {
    submit() {
      this.formData.businessId = this.businessId;
      this.$emit("submit", this.formData);
    },
    resetForm() {
      if (this.emptyModel) {
        this.formData = JSON.parse(JSON.stringify(this.emptyModel));
        this.$refs.validationObserver && this.$refs.validationObserver.reset();
      } else {
        console.error("emptyModel is not defined");
      }
    },
    async loadData() {
      if (!this.id) this.id = this.$route.params.id;
      if (this.id)
        this.formData = await getOrderData({
          businessId: this.formData.businessId,
          branchId: this.formData.branchId,
          id: this.id
        });
      if (this.model) this.formData = { ...this.model };
      if (this.createForm) {
      }
    }
  }
};
</script>
<style scoped></style>
